import { CardCategoryEntity } from '@entities/desktop/cards';

import { CardCategoryMobileProps } from './card-market.types';
export const CardMarketEntityMobile = ({
  ...props
}: CardCategoryMobileProps) => {
  return <CardCategoryEntity {...props} />;
};
